import React from 'react';
import { Route } from 'react-router-dom';
import RouteMenu from 'mrf/view/MenuRoute';
import path from 'path';
import InstitutionList from 'components/system/institution/InstitutionList';
import InstitutionForm from 'components/system/institution/InstitutionForm';


export default function Institution({ match }) {
    return (
        <RouteMenu match={match} indexComponent={InstitutionList}>
            <Route path={path.join(match.url, 'new')} component={InstitutionForm} />
            <Route path={path.join(match.url, 'edit/:id')} component={InstitutionForm} />
        </RouteMenu>
    );
}